'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Comment = require('./Comment');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Comment).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Comment/index.js
// module id = 1161
// module chunks = 1